import {Card, CardContent, Typography} from "@material-ui/core";
import AppColors from "../../colors/AppColors";
import React from "react";
import StakeAmountField from "../../views/StakeAmountField";
import UsersManager from "../../managers/UsersManager";

export const StakeView = React.forwardRef(function (props: any, ref: any) {

    const loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string);

    return <Card
        style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            backgroundColor: AppColors.CARD_BACKGROUND_COLOR,
            borderRight: 'none'
        }}>
        <CardContent>
            <Typography
                align={"center"}
                style={{
                    color: AppColors.EASE_GRAY,
                    paddingBottom: 5,
                    paddingTop: 5,
                    fontSize: 12,
                    textAlign: 'center',
                    fontWeight: 'bold',
                }}>STAKE PER TICKET (BTC):</Typography>
            <StakeAmountField ref={ref}/>
            <Typography
                style={{
                    fontSize: 12,
                    color: `${AppColors.GREY_TEXT}`,
                    paddingTop: 2,
                    textAlign: 'center'
                }}
                dangerouslySetInnerHTML={{__html: `Minimum = <b>${loggedInUser["minBetAmount"]} BTC</b><br/>Maximum = <b>${loggedInUser["maxBetAmount"]} BTC</b>`}}/>
        </CardContent>
    </Card>
});

export default StakeView;